import React from "react";

type H3Props = {
  children:  React.ReactElement | any;
  bold?: boolean;
  fontType?: string;
  color?: string;
  className?: string;
};
const H3: React.FC<H3Props> = ({
  children,
  bold,
  color = "text-blueishblack",
  fontType = "regular",
  className,
}): React.ReactElement => {
  const _fType = bold ? "bold" : fontType;

  return <h3 className={`text-3xl ${color} ${className}`}>{children}</h3>;
};

export default H3;
